import { Routes } from '@angular/router';
import { DashboardComponent } from '../../pages/dashboard/dashboard.component';
import { NotfoundComponent } from '../../pages/notfound/notfound.component';
import { ProductCreateOrUpdateComponent } from '../../pages/product/product-create-or-update/product-create-or-update.component';
import { ProductListComponent } from '../../pages/product/product-list/product-list.component';
import { InternalComponent } from './internal.component';
import { BrandListComponent } from '../../pages/brand/brand-list/brand-list.component';
import { BrandCreateOrUpdateComponent } from '../../pages/brand/brand-create-or-update/brand-create-or-update.component';
import { CategoryListComponent } from '../../pages/category/category-list/category-list.component';
import { CategoryCreateOrUpdateComponent } from '../../pages/category/category-create-or-update/category-create-or-update.component';
import { ModelCreateOrUpdateComponent } from '../../pages/model/model-create-or-update/model-create-or-update.component';
import { ModelListComponent } from '../../pages/model/model-list/model-list.component';
import { ModelVersionListComponent } from '../../pages/model-version/model-version-list/model-version-list.component';
import { ModelVersionCreateOrUpdateComponent } from '../../pages/model-version/model-version-create-or-update/model-version-create-or-update.component';
import { VariationAttributeListComponent } from '../../pages/variation-attribute/variation-attribute-list/variation-attribute-list.component';
import { VariationAttributeCreateOrUpdateComponent } from '../../pages/variation-attribute/variation-attribute-create-or-update/variation-attribute-create-or-update.component';
import { VariationAttributeValueListComponent } from '../../pages/variation-attribute-value/variation-attribute-value-list/variation-attribute-value-list.component';
import { VariationAttributeValueCreateOrUpdateComponent } from '../../pages/variation-attribute-value/variation-attribute-value-create-or-update/variation-attribute-value-create-or-update.component';
import { ProductDetailsComponent } from '../../pages/product/product-details/product-details.component';
import { PaymentFrequencyListComponent } from '../../pages/payment-frequency/payment-frequency-list/payment-frequency-list.component';
import { PaymentFrequencyCreateOrUpdateComponent } from '../../pages/payment-frequency/payment-frequency-create-or-update/payment-frequency-create-or-update.component';
import { LateFeePolicyListComponent } from '../../pages/late-fee-policy/late-fee-policy-list/late-fee-policy-list.component';
import { LateFeePolicyCreateOrUpdateComponent } from '../../pages/late-fee-policy/late-fee-policy-create-or-update/late-fee-policy-create-or-update.component';
import { CustomerListComponent } from '../../pages/customer/customer-list/customer-list.component';
import { CustomerDetailsComponent } from '../../pages/customer/customer-details/customer-details.component';
import { OfferListComponent } from '../../pages/offer/offer-list/offer-list.component';
import { OfferCreateOrUpdateComponent } from '../../pages/offer/offer-create-or-update/offer-create-or-update.component';
import { EmployeeListComponent } from '../../pages/employee/employee-list/employee-list.component';
import { EmployeeCreateOrUpdateComponent } from '../../pages/employee/employee-create-or-update/employee-create-or-update.component';
import { AssessmentListComponent } from '../../pages/assessment/assessment-list/assessment-list.component';
import { AssessmentCreateOrUpdateComponent } from '../../pages/assessment/assessment-create-or-update/assessment-create-or-update.component';
import { AssessmentRuleCreateOrUpdateComponent } from '../../pages/assessment-rule/assessment-rule-create-or-update/assessment-rule-create-or-update.component';
import { AssessmentRuleListComponent } from '../../pages/assessment-rule/assessment-rule-list/assessment-rule-list.component';
import { privateOnlyCanMatch } from '../../../guards/auth-private.guard';
import { ParameterListComponent } from '../../pages/parameter/parameter-list/parameter-list.component';
import { ParameterUpdateComponent } from '../../pages/parameter/parameter-update/parameter-update.component';
import { TextContentListComponent } from '../../pages/text-content/text-content-list/text-content-list.component';
import { TextContentUpdateComponent } from '../../pages/text-content/text-content-update/text-content-update.component';
import { DisplayAreaListComponent } from '../../pages/display-area/display-area-list/display-area-list.component';
import { DisplayAreaUpdateComponent } from '../../pages/display-area/display-area-update/display-area-update.component';
import { OrderListComponent } from '../../pages/order/order-list/order-list.component';
import { OrderDetailsComponent } from '../../pages/order/order-details/order-details.component';
import { CarrierListComponent } from '../../pages/carrier/carrier-list/carrier-list.component';
import { CarrierCreateOrUpdateComponent } from '../../pages/carrier/carrier-create-or-update/carrier-create-or-update.component';
import { ProductIdentifierTypeListComponent } from '../../pages/product-identifier-type/product-identifier-type-list/product-identifier-type-list.component';
import { ProductIdentifierTypeCreateOrUpdateComponent } from '../../pages/product-identifier-type/product-identifier-type-create-or-update/product-identifier-type-create-or-update.component';
import { TaxRateCreateOrUpdateComponent } from '../../pages/tax-rate/tax-rate-create-or-update/tax-rate-create-or-update.component';
import { TaxRateListComponent } from '../../pages/tax-rate/tax-rate-list/tax-rate-list.component';
import { ContractTemplateListComponent } from '../../pages/contract-template/contract-template-list/contract-template-list.component';
import { ContractTemplateCreateOrUpdateComponent } from '../../pages/contract-template/contract-template-create-or-update/contract-template-create-or-update.component';

export const internalRoutes: Routes = [
  {
    path: '',
    component: InternalComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canMatch: [privateOnlyCanMatch],
      },

      //======= Product management
      {
        path: 'products',
        component: ProductListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'products/create',
        component: ProductCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'products/update/:id',
        component: ProductCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'products/details/:id',
        component: ProductDetailsComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'brands',
        component: BrandListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'brands/create',
        component: BrandCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'brands/update/:id',
        component: BrandCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'categories',
        component: CategoryListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'categories/create',
        component: CategoryCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'categories/update/:id',
        component: CategoryCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'models',
        component: ModelListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'models/create',
        component: ModelCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'models/update/:id',
        component: ModelCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'model-versions',
        component: ModelVersionListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'model-versions/create',
        component: ModelVersionCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'model-versions/update/:id',
        component: ModelVersionCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'variation-attributes',
        component: VariationAttributeListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'variation-attributes/create',
        component: VariationAttributeCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'variation-attributes/update/:id',
        component: VariationAttributeCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'variation-attribute-values',
        component: VariationAttributeValueListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'variation-attribute-values/create',
        component: VariationAttributeValueCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'variation-attribute-values/update/:id',
        component: VariationAttributeValueCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      //======= Offer management
      {
        path: 'offers',
        component: OfferListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'offers/create',
        component: OfferCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'offers/update/:id',
        component: OfferCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'payment-frequencies',
        component: PaymentFrequencyListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'payment-frequencies/create',
        component: PaymentFrequencyCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'payment-frequencies/update/:id',
        component: PaymentFrequencyCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'late-fee-policies',
        component: LateFeePolicyListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'late-fee-policies/create',
        component: LateFeePolicyCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'late-fee-policies/update/:id',
        component: LateFeePolicyCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      {
        path: 'employees',
        component: EmployeeListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'employees/create',
        component: EmployeeCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'employees/update/:id',
        component: EmployeeCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      {
        path: 'customers',
        component: CustomerListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'customers/details/:id',
        component: CustomerDetailsComponent,
        canMatch: [privateOnlyCanMatch],
      },

      //======= Order management
      {
        path: 'orders',
        component: OrderListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'orders/details/:id',
        component: OrderDetailsComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'contract-templates',
        component: ContractTemplateListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'contract-templates/create',
        component: ContractTemplateCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'contract-templates/update/:id',
        component: ContractTemplateCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'assessments',
        component: AssessmentListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'assessments/create',
        component: AssessmentCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'assessments/update/:id',
        component: AssessmentCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'assessment-rules',
        component: AssessmentRuleListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'assessment-rules/create',
        component: AssessmentRuleCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'assessment-rules/update/:id',
        component: AssessmentRuleCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'product-identifier-types',
        component: ProductIdentifierTypeListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'product-identifier-types/create',
        component: ProductIdentifierTypeCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'product-identifier-types/update/:id',
        component: ProductIdentifierTypeCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'carriers',
        component: CarrierListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'carriers/create',
        component: CarrierCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'carriers/update/:id',
        component: CarrierCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      //======= Display Area
      {
        path: 'display-areas',
        component: DisplayAreaListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'display-areas/update/:id',
        component: DisplayAreaUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      //======= Parameters
      {
        path: 'parameters',
        component: ParameterListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'parameters/update/:id',
        component: ParameterUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      //======= Text Content
      {
        path: 'text-contents',
        component: TextContentListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'text-contents/update/:id',
        component: TextContentUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      // Tax Rate management
      {
        path: 'tax-rates',
        component: TaxRateListComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'tax-rates/create',
        component: TaxRateCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },
      {
        path: 'tax-rates/update/:id',
        component: TaxRateCreateOrUpdateComponent,
        canMatch: [privateOnlyCanMatch],
      },

      {
        path: 'notfound',
        component: NotfoundComponent,
      },
    ],
  },
];
